exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product__btn[data-v-3f429295]{width:80px;text-align:center;height:40px;color:#fff;line-height:36px}.product__btn img[data-v-3f429295]{width:20px}.product__btn--add[data-v-3f429295]{background-color:#6aceff}.product-detail__btn[data-v-3f429295]{width:auto;text-align:center;height:70px;color:#fff;padding:0 30px;background-color:#6aceff;display:flex;align-items:center;line-height:auto}.product-detail__btn img[data-v-3f429295]{width:40px}.product-detail__btn span[data-v-3f429295]{font-family:ClanProBold;font-size:14px;margin-right:20px;text-align:left}.product-detail__btn[data-v-3f429295]:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f429295","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Product/ProductAddToCart.vue
// module id = 436
// module chunks = 0